function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeMiterlimit: 10,
  d: "M294.1,408.2c0,0.4,0,0.7,0,1.1c-0.3,1-0.9,1.7-2,2 c-1,0.3-1.9,0-2.7-0.7c-0.3-0.3-0.4-0.6-0.7-0.7c-0.3-0.3-0.6-0.4-1-0.4c-0.6,0-1.1,0.3-1.3,0.9c-0.1,0.4-0.1,1,0.3,1.4 c0.3,0.3,0.6,0.6,0.7,0.9c1,1,1,2.6,0.1,3.7c-0.6,0.6-1.3,1-2.2,1c-0.4,0-0.7,0-1.1,0c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.4,1.3,1.1,1.4 c0.1,0,0.3,0,0.4,0c0.4,0,1,0,1.4,0c1.3,0.1,2.4,1.4,2.3,2.9c0,0.7-0.3,1.4-0.9,1.9c-0.3,0.3-0.4,0.4-0.7,0.7 c-0.4,0.4-0.6,0.9-0.3,1.4c0.3,1,1.6,1.3,2.3,0.6c0.3-0.3,0.6-0.6,0.9-0.9c0.7-0.7,1.6-0.9,2.6-0.7c1.3,0.3,2,1.4,2,2.6 c0,0.4,0,0.9,0,1.1c0,0.7,0.6,1.4,1.3,1.4s1.4-0.6,1.4-1.4c0-0.3,0-0.7,0-1c0-0.1,0-0.3,0-0.6c0.3-1.3,1.4-2.2,2.6-2.3 c0.9,0,1.6,0.3,2.2,0.9c0.3,0.3,0.4,0.4,0.7,0.7c0.4,0.3,0.9,0.4,1.3,0.3c1-0.3,1.4-1.6,0.7-2.3c-0.3-0.3-0.4-0.4-0.7-0.7 c-0.6-0.6-0.9-1.3-0.9-2.2c0.1-1.4,1.3-2.6,2.7-2.6c0.3,0,0.7,0,1,0c0.1,0,0.3,0,0.4,0c0.7-0.1,1-0.9,1-1.6 c-0.1-0.7-0.7-1.1-1.4-1.1c-0.3,0-0.7,0-1,0s-0.4,0-0.7,0c-1.4-0.3-2.4-1.9-2.2-3.2c0.1-0.6,0.4-1.1,0.9-1.4 c0.3-0.3,0.4-0.4,0.7-0.7s0.4-0.9,0.3-1.3c-0.1-0.6-0.4-0.9-1-1c-0.6-0.1-1,0-1.4,0.3c-0.3,0.3-0.4,0.4-0.7,0.7 c-0.7,0.6-1.4,0.9-2.3,0.9c-1.4-0.1-2-1.3-2-2.7c0-0.3,0-0.7,0-1c0-0.4,0-0.4,0-0.4c-0.1-0.7-0.7-1.1-1.4-1.1s-1.3,0.6-1.3,1.1 C294.1,407.6,294.1,407.9,294.1,408.2z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeMiterlimit: 10,
  d: "M297.1,422.7c-1.3,0-2.3-1-2.4-2.3c0-1.3,1-2.4,2.3-2.4 c1.3,0,2.4,1,2.4,2.3C299.5,421.4,298.5,422.7,297.1,422.7z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeMiterlimit: 10,
  d: "M291.8,416.4c0-0.7,0.6-1.4,1.4-1.4c0.7,0,1.4,0.6,1.4,1.4 c0,0.7-0.6,1.4-1.4,1.4C292.3,417.8,291.8,417.1,291.8,416.4z"
});

var SvgCovidReporting = function SvgCovidReporting(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "281.6 405.1 26.2 27.5",
    enableBackground: "new 281.6 405.1 26.2 27.5",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCovidReporting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/covid_reporting.fd0f0c87.svg";
export { ForwardRef as ReactComponent };